// MarketUsdtSettlementVault.InsufficientUsdtLiquidity(). The payout ABI may
// not decode this nested settlement revert, so retain its exact raw selector.
const INSUFFICIENT_USDT_LIQUIDITY = "0x4e310c25";

export function marketRewardClaimErrorMessage(error: Error | null | undefined): string | undefined {
  // Presentation only: callers must keep the failed mutation and retry state.
  // Do not match message text: "insufficient funds" can mean the user's BNB,
  // while a liquidity RPC error does not establish a vault balance shortage.
  const visited = new Set<object>();
  let current: unknown = error;
  while (current && typeof current === "object" && !visited.has(current)) {
    visited.add(current);
    const detail = current as Record<string, unknown>;
    const data = detail.data;
    if (detail.code === "MARKET_USDT_LIQUIDITY_UNAVAILABLE"
      || detail.raw === INSUFFICIENT_USDT_LIQUIDITY
      || detail.signature === INSUFFICIENT_USDT_LIQUIDITY
      || (data && typeof data === "object"
        && "errorName" in data && data.errorName === "InsufficientUsdtLiquidity")) {
      return undefined;
    }
    current = detail.cause;
  }
  return error?.message;
}
